<template>
  <div class="page">
    <div class="headimg">
      <img width="100%" src="../assets/zxyfw-2.jpg" alt="">
    </div>
    <div class="nav">
      <div class="nav-item">
        <p class="title">为何选择INCO</p>
        <p class="text" @click="goFile()" style="cursor: pointer;">
          <Icon style="padding-right: 10px" size="16" type="md-arrow-forward" />阅读解决方案简介（PDF，KB）
        </p>
      </div>
      <div class="nav-item" v-for="(item, index) in navList" :key="index" style="line-height: 70px;">{{item}}
      </div>
    </div>
    <div class="cell-wrap">
      <div class="left-wrap">服务宗旨</div>
      <div class="right-wrap">
        <div style="padding-bottom: 30px">
          在INCO，一切工作的核心都是营造出色的用户体验，即便是在用户看不到的地方。INCO始终关注用户需求，坚持用心沟通，努力为用户提供出色的产品、体验和支持服务。我们通过多渠道的便捷服务，满足不同用户的多样化需求，不断提升用户满意度，用真诚、专业、高品质的服务，赢得用户的认可与信赖。
        </div>
      </div>
    </div>
    <div class="cell-wrap">
      <div class="left-wrap">精细化项目<br>管理模式</div>
      <div class="right-wrap">
        <img class="img" src="../assets/zxyfw-3.jpg" alt="">
        <span class="text">以IT系统连接参与学校信息化建设的信息化部门和业务部门老师、公司实施团队、工程专家、产品专家、产品经理、开发人员、运维专家和合作伙伴，实现软件交付过程的精细化管理与共创，提高交付质量。
          实施动作标准化经验复用，工作量清晰化，任务进度计划管控过程透明化、全程跟踪反馈！项目文档分类清晰，成果可视化。
        </span>
      </div>
    </div>
    <div style="background: rgb(218,215,217);">
      <div class="cell-wrap">
        <div class="left-wrap">运维安全服务</div>
        <div class="right-wrap">
          <Row type="flex" justify="space-between">
            <Col span="12">
            <Card class="bg">
              <img width="60" src="../assets/ico_1.png" alt="">
              <p class="title">提供管家式服务</p>
              <p class="content">精细化主动运维，免除后顾之忧，放心聚焦业务</p>
            </Card>
            </Col>
            <Col span="12">
            <Card class="bg">
              <img width="60" src="../assets/ico_2.png" alt="">
              <p class="title">7*24小时主动监控</p>
              <p class="content">7*24小时主动监控，防患未然。</p>
            </Card>
            </Col>
            <Col span="12">
            <Card class="bg">
              <img width="60" src="../assets/ico_3.png" alt="">
              <p class="title">问题处理全过程可见</p>
              <p class="content">责任人、处理进度获知</p>
            </Card>
            </Col>
            <Col span="12">
            <Card class="bg">
              <img width="60" src="../assets/ico_4.png" alt="">
              <p class="title">主动监测+专家团队</p>
              <p class="content">精准定位故障问题，快速处理，保障系统可用性</p>
            </Card>
            </Col>
          </Row>
        </div>
      </div>
    </div>

    <div class="cell-wrap">
      <div class="left-wrap">运营迭代服务</div>
      <div class="right-wrap">
        <img width="100%" src="../assets/zxyfw-5.jpg" alt="">
      </div>
    </div>
    <div style="height: 100px;margin-bottom: 30px;background: rgb(60,60,60)"></div>
    <div class="technology-wrap">
      <div class="technology">
        <div class="title">技术优势</div>
        <div class="card-wrap">
          <Row type="flex" justify="space-between">
            <Col span="8">
            <Card class="bg" :bordered="false" :dis-hover="false">
              <p class="title">完整的软件体系架构</p>
              <img width="60" src="../assets/ico_5.png" alt="">
              <p class="text">采用多层级、低耦合、模块化的软件架构，提供C/S和B/S两种系统设计，既能够满足管理用户集中、大量的数据处理要求，又能够保证普通师生日常便捷地使用。</p>
            </Card>
            </Col>
            <Col span="8">
            <Card class="bg" :bordered="false" :dis-hover="false">
              <p class="title">严格的安全防护机制</p>
              <img width="60" src="../assets/ico_6.png" alt="">
              <p class="text">基于用户角色权限对页面、数据和功能进行精准访问控制；通过DES64、MD5和自主设计的加密算法，对用户密码、试卷、成绩等敏感数据进行加密签名；定时审计数据一致性、完整性、真实性，确保系统信息安全。</p>
            </Card>
            </Col>
            <Col span="8">
            <Card class="bg" :bordered="false" :dis-hover="false">
              <p class="title">成熟的系统拓扑结构</p>
              <img width="60" src="../assets/ico_7.png" alt="">
              <p class="text">采用J2EE架构及多种分级缓存、负载均衡技术搭建系统，通过集群方式部署Linux系统平台，能够平稳应对海量数据运算存储和选课、成绩查询等高并发应用场景，并根据需要灵活进行升级扩容。</p>
            </Card>
            </Col>
          </Row>
		  <Row type="flex" justify="space-between">
		    <Col span="8">
		    <Card class="bg" :bordered="false" :dis-hover="false">
		      <p class="title">强大的数据挖掘能力</p>
		      <img width="60" src="../assets/ico_8.png" alt="">
		      <p class="text">形成高校教学管理大数据，建设教学数据挖掘应用，科学构建指标体系和计算模型，将日常真实留痕的业务数据转化为客观可量化的评价数据，为持续改进教学工作、推进教学改革提供决策支持。</p>
		    </Card>
		    </Col>
		    <Col span="8">
		    <Card class="bg" :bordered="false" :dis-hover="false">
		      <p class="title">人性化的人机交互界面</p>
		      <img width="60" src="../assets/ico_9.png" alt="">
		      <p class="text">可根据当前用户身份和设置，自动生成个性化的工作、学习、管理界面的系统，并随教学管理进程自动显示当前需要使用的系统功能，推送当前需要关注的提示信息。</p>
		    </Card>
		    </Col>
		    <Col span="8">
		    <Card class="bg" :bordered="false" :dis-hover="false">
		      <p class="title">丰富的二次开发接口</p>
		      <img width="60" src="../assets/ico_10.png" alt="">
		      <p class="text">从数据、功能、组件、界面等不同应用层级设计，提供大量服务访问和开发接口，供高校根据特定需求进行功能拓展和个性化定制开发。</p>
		    </Card>
		    </Col>
		  </Row>
        </div>
      </div>
    </div>
    <div class="cell-wrap">
      <div class="left-wrap">服务院校</div>
      <div class="right-wrap">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide v-for="(item, index) in schoolList" :key="index">
            <div class="item" :style="{backgroundImage: 'url(' + item.img + ')', backgroundSize:'100% 100%', backgroundRepeat: 'no-repeat'}"></div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="case-wrap">
      <div class="case">
        <div class="title">经典案例</div>
        <div class="card-wrap">
          <Row :gutter="16" type="flex" justify="start" class="code-row-bg">
            <Col span="8" v-for="(item, index) in expList" :key="index">
            <Card class="bg">
              <p class="title">{{item.title}}</p>
              <p class="text">{{item.remark01}}</p>
              <p class="check" @click="jumpPdf(item.id)" style="cursor: pointer;">获取案例信息</p>
            </Card>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      navList: ['更专业', '更快捷', '更安全'],
      swiperOption: {
        slidesPerView: 7,
        spaceBetween: 5,
      },
      schoolList: [],
      expList: [],
    }
  },
  methods: {
    getStyles(index) {
      return {
        backgroundImage: 'url(' + require(`../assets/cp-${index}.jpg`) + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }
    },
	isEmpty(obj) {
	  if (typeof obj == 'undefined' || obj == null || obj == '') {
	    return true
	  } else {
	    return false
	  }
	},
	jumpPdf(id) {
		// this.$router.push({
		//   path: 'newsdetail',
		//   query: { id: id },
		// })
		
		let routeUrl = this.$router.resolve({
		    path: 'newsdetail',
		    query: { id: id },
		   });
		window.open(routeUrl.href, '_blank');
	},
	goFile(){
		window.open(this.HOST+"incon/upFile/accessory/xcsc_01.pdf")
	}
  },
  mounted() {
    let url =
      this.HOST +
      'wzPage/getJson?id=D8E6B18091771CC6E05509994F3826F5&moduleOrder=ordernum&contentOrder=ordernum&websiteid=4'
    url = this.$getJsonUrl(url)
    this.$axios.get(url).then((res) => {

      this.schoolList = res.data.content[0].children[0].children[1].list
      this.expList = res.data.content[0].children[0].children[0].list
    })
  },
}
</script>

<style scoped lang="less">
.swiper {
  width: 780px;
  .swiper-slide {
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    .item {
      width: 100%;
      height: 0;
      padding-bottom: 100%;
    }
  }
}
.page {
  font-size: 0;
  .nav {
    display: flex;
    align-items: center;
    min-width: 1000px;
    margin-bottom: 30px;
    background-image: url('../assets/zpqs-3.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    .nav-item {
      flex: 1;
      height: 70px;
      font-size: 26px;
      font-weight: bold;
      text-align: center;
      color: #fff;
      border-right: 1px solid white;
      &:last-child {
        border-right: 0 solid white;
      }
      .title {
        font-size: 24px;
        line-height: 45px;
        font-weight: normal;
      }
      .text {
        font-size: 12px;
        // line-height: 20px;
        font-weight: normal;
      }
    }
  }
  .cell-wrap {
    display: flex;
    width: 1000px;
    margin: 0 auto;
    padding: 10px 0;
    .left-wrap {
      width: 120px;
      margin-right: 100px;
      font-size: 18px;
      font-weight: 500;
      text-align: left;
    }
    .right-wrap {
      flex: 1;
      font-size: 16px;
      .img {
        width: 50%;
        // height: 200px;
        vertical-align: top;
      }
      .text {
        display: inline-block;
        width: 50%;
        // height: 200px;
        padding-left: 120px;
        box-sizing: border-box;
        vertical-align: top;
      }
      .title {
        font-size: 18px;
        font-weight: 500;
      }
    }
  }
  .case-wrap {
    background: rgb(218, 215, 217);
  }
  .case,
  .technology {
    display: flex;
    width: 1000px;
    margin: 0 auto;
    padding: 10px 0;
    .title {
      width: 120px;
      margin-right: 100px;
      font-size: 18px;
      font-weight: 500;
      text-align: left;
    }
    .card-wrap {
      flex: 1;
      .bg {
        margin-bottom: 10px;
        .title {
          overflow: hidden;
          display: -webkit-box;
          word-break: break-all;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          width: 100%;
          height: 25px;
          padding-right: 0;
          margin-bottom: 18px;
          line-height: 25px;
          font-size: 18px;
          font-weight: 500;
          text-align: left;
        }
        .text {
          height: 190px;
          font-size: 16px;
        }
        .check {
          font-size: 12px;
          line-height: 60px;
        }
      }
    }
  }
  .technology {
    .card-wrap {
      .bg {
        border-bottom: 1px solid #999;
        .title {
          height: 25px;
          margin-bottom: 5px;
          line-height: 30px;
        }
        .text {
          font-size: 16px;
          padding-top: 20px;
        }
      }
    }
  }
}
.card-wrap /deep/ .ivu-card {
  border-radius: 0;
}
.cell-wrap /deep/ .ivu-card {
  border-radius: 0;
}

.technology .card-wrap /deep/ .ivu-card-body {
  padding: 0 16px 0 16px;
}
</style>